module.exports = __webpack_public_path__ + "img/ZMCafe.6fbb2ed5.jpg";